import Collection from './Collection';

export default Collection;
export { Collection };


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/dist/es/Collection/index.js
// module id = 1841
// module chunks = 1